module.exports = __webpack_public_path__ + "static/media/balmain_5.e6ddeef3.jpg";